export default __webpack_public_path__ + "static/media/redeem.da8617bd.svg";